export { default } from './dealer';
